import React, { useState, useEffect } from "react";
import { Layout, Input, Badge, Avatar, Space, Tooltip } from "antd";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  BellOutlined,
  UserOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "../assets/css/Home.css";
import NotificationCenter from "./NotificationCenter"; // ajuste o path
import UserProfileModal from "./UserProfileModal";       // ajuste o path

const { Header } = Layout;

const Topbar = ({ collapsed, onToggle }) => {

  const userStored = JSON.parse(localStorage.getItem("user"));
  const [profileOpen, setProfileOpen] = useState(false);

  return (
    <Header className="app-header" style={{ zIndex: 1001 }}>

      <div style={{ position: "fixed", top: 16, right: 60, zIndex: 1001 }}>
        <NotificationCenter />
      </div>

      <div className="header-left">
        <button className="sider-toggle-btn" onClick={onToggle}>
          {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
        </button>
      </div>

      <div className="header-right">

        <Space size="large" align="center" className="header-actions">

          <div
            className="header-user"
            onClick={() => setProfileOpen(true)}
            style={{ cursor: "pointer" }}
          >
            <div className="user-info">
              <span className="user-name">{userStored.nome}</span>
            </div>
            <Avatar icon={<UserOutlined />} />
          </div>
        </Space>
      </div>

      <UserProfileModal
        open={profileOpen}
        onClose={() => setProfileOpen(false)}
      />
    </Header>
  );
};

export default Topbar;